import React, { useEffect, useState } from 'react';
import { getFeatures } from '../../api/api';
import IconList from '../../components/IconList/IconList';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { Link } from 'react-router-dom';
import './Features.scss';

const Features = () => {
    const [features, setFeatures] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const data = await getFeatures();
            setFeatures(data);
        }
        fetchData();
    }, []);

    return (
      <section
        className="section-bg section-common features-section pt-100 pb-70"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <div className="container">
          <SectionTitle
            subTitle="Features"
            title="Specialized  care through experiences"
            description="Personalized treatments, advanced technology, and a patient-first approach for a healthier, brighter smile."
          />

          <div className="row align-items-center">
            {features.map((singleFeature) => (
              <IconList
                key={singleFeature.id}
                icon={singleFeature.icon_url || null}
                title={singleFeature.title}
                description={singleFeature.description}
              />
            ))}
          </div>

          {/* AI Dental Checkup Feature */}
          <div className="ai-feature-section text-center mt-5" data-aos="fade-up" data-aos-duration="2000">
            <div className="ai-feature-card">
              <div className="ai-feature-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>AI-Powered Dental Analysis</h3>
              <p>Experience the future of dental care with our advanced AI technology. Get instant insights and recommendations for your oral health.</p>
              <Link to="/dental-checkup" className="ai-feature-btn">
                Try AI Checkup
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
};

export default Features;